import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import BasketPopupContainer from './BasketPopupContainer';
import { ComparePopupContainer } from './ComparePopupContainer';
const EssentialsContainer = ({ basketPopUp }) => {
    const { feature_toggles: { lowest_price_all }, } = useAemConfig();
    return (_jsxs(_Fragment, { children: [_jsx(BasketPopupContainer, { recommendations: basketPopUp, enablePriceReference: lowest_price_all }), _jsx(ComparePopupContainer, {})] }));
};
export default EssentialsContainer;
